import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiService: ApiService
  ) {}

  checkExpiration(): Observable<boolean> {
    return this.http.get<boolean>(this.apiService.buildUrl('api/user/CheckExpiration'));
  }
}
